// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Pl2GanttLeftHeadCell-Pl2GanttLeftHeadCell-module__selection--AZj5O {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 0 0;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Pl2GanttLeftHeadCell-Pl2GanttLeftHeadCell-module__resizable--iHURV {
  position: relative;
  display: flex;
  align-items: flex-start;
  height: 100%;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Pl2GanttLeftHeadCell-Pl2GanttLeftHeadCell-module__resizable--iHURV .src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Pl2GanttLeftHeadCell-Pl2GanttLeftHeadCell-module__title--0fLhv {
  padding: 6px 8px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  overflow-wrap: anywhere;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-size: 12px;
  font-weight: 500;
  line-height: 160%;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsPlanning2/Planning2Control/Planning2Gantt/Pl2GanttLeftHeadCell/Pl2GanttLeftHeadCell.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AACF;AALA;EAOI,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EAEA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAAJ","sourcesContent":[".selection {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 4px 0 0;\n}\n.resizable {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  height: 100%;\n\n  .title {\n    padding: 6px 8px 0;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    line-clamp: 2;\n    -webkit-line-clamp: 2;\n    overflow-wrap: anywhere;\n    overflow: hidden;\n\n    color: rgba(0, 0, 0, 0.85);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 160%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selection": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Pl2GanttLeftHeadCell-Pl2GanttLeftHeadCell-module__selection--AZj5O`,
	"resizable": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Pl2GanttLeftHeadCell-Pl2GanttLeftHeadCell-module__resizable--iHURV`,
	"title": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Pl2GanttLeftHeadCell-Pl2GanttLeftHeadCell-module__title--0fLhv`
};
export default ___CSS_LOADER_EXPORT___;
